import '../CustomerDetails.css';
import { React, useState, useContext } from 'react';
import imageCompression from "browser-image-compression";
import { AppContext } from '../../../services/AppContext';
import { useTranslation } from 'react-i18next';

const CreateCustomer = ({ closeModal }) => {
    const { t } = useTranslation();
    const { apiClient, setIsLoading, notify } = useContext(AppContext);
    const [newCustomer, setNewCustomer] = useState({ role: 2, name:'', username:'', phone:'',notes:'', picture:null });

    const handleSaveCustomer = async () => {
        setIsLoading(true);

        const formData = new FormData();
        formData.append('name', newCustomer.name || '');
        formData.append('username', newCustomer.username || '');
        formData.append('phone', newCustomer.phone || '');
        formData.append('notes', newCustomer.notes || '');
        formData.append('role', 2);

        try {
            if (newCustomer.picture) {
                const options = {
                    maxSizeMB: 0.1, // Maximum size in MB
                    maxWidthOrHeight: 512, // Maximum width/height in pixels
                    useWebWorker: true, // Enable web worker for better performance
                };
                const compressedFile = await imageCompression(newCustomer.picture, options);
                formData.append('picture', compressedFile);
            }

            const result = await apiClient.createUser(formData);

            if (result.hasErrors) {
                return;
            }
            closeModal(true);

            notify(t('pages.customers.modals.successMessage'), 'success');
            setNewCustomer({});
        } catch (error) {
            notify(error.message, 'error');
        } finally {
            setIsLoading(false);
        }
    };

    const handleCancel = () => {
        closeModal(false);
        setNewCustomer({});
    };

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'picture') {
            setNewCustomer((prev) => ({
                ...prev,
                [name]: files[0], // Store the selected file
            }));
        } else {
            setNewCustomer((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    return (<div className="modal">
        <div className="modal-content">
            <h3>{t('pages.customers.modals.addNewCustomer')}</h3>
            <input
                type="text"
                name="name"
                placeholder={t('pages.customers.modals.namePlaceholder')}
                value={newCustomer.name}
                onChange={handleChange}
            />
            <input
                type="text"
                name="phone"
                placeholder={t('pages.customers.modals.phonePlaceholder')}
                value={newCustomer.phone || ''}
                onChange={handleChange}
            />
            <input
                type="text"
                name="notes"
                placeholder={t('pages.customers.modals.notesPlaceholder')}
                value={newCustomer.notes || ''}
                onChange={handleChange}
            />
            <input
                type="file"
                name="picture"
                accept="image/*" // Restrict file selection to images
                onChange={handleChange}
            />
            <input
                type="text"
                name="username"
                placeholder={t('pages.customers.modals.usernamePlaceholder')}
                value={newCustomer.username}
                onChange={handleChange}
            />

            <div className='container'>
                <button className='mg-r-1 width-100p' onClick={handleSaveCustomer}>{t('pages.customers.modals.saveButton')}</button>
                <button className='width-100p' onClick={handleCancel}>{t('pages.customers.modals.cancelButton')}</button>
            </div>
        </div>
    </div>
    )
};

export default CreateCustomer;